// @flow

import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import ContactForm from "../ContactForm";
import animateScrollTo from "animated-scroll-to";
import "./Footer.scss";

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div >
          <section className="lp-contact">
            <div className="container">
              <div className="container contact-form-container row">
                <h2 className="col-12 heading title-basic">
                  {" "}
                  Masz pytania?{" "}
                  <span className="subheading">Skontaktuj się z nami</span>
                </h2>

                <div className="contact__left col-6 col-m-12">
                  <h5 className="contact__heading text-basic">
                    Dane kontaktowe
                  </h5>
                  <div className="footer__contact">
                    <span className="af-icon-mail" />

                    <ul className="text-basic">
                      <li>
                        <a href="tel:0048717838301">+48 71 78 38 301</a>
                      </li>
                      <li>
                        <a href="tel:0048717838300">+48 71 78 38 300</a>
                      </li>
                      <li>
                        <a href="mailto:kontakt@selena.com">
                          kontakt@selena.com
                        </a>
                      </li>
                    </ul>
                  </div>
                  <h5 className="contact__heading text-basic">
                    Adres Selena S.A.
                  </h5>
                  <div className="footer__contact">
                    <span className="af-icon-place" />
                    <ul className="text-basic">
                      <li>ul. Wyścigowa 56E,</li>
                      <li>53-012 Wrocław, Polska </li>
                      <li>NIP: 894-000-55-23</li>
                      <li>KRS: 0000112580</li>
                    </ul>
                  </div>
                </div>

                <div className="contact__right col-6 col-m-12">
                  <ContactForm />
                </div>
              </div>

              <div
                onClick={e => {
                  animateScrollTo(document.querySelector("#roof-main"));
                }}
                className="scroll-button"
              >
                <span className="af-icon-arrow-bottom"></span>
              </div>
            </div>
          </section>

          <section id="kontakt" className="lp-footer">
            <div className="row container footer">
              <div className="footer__left-side col-12 col-m-12">
                <p className="text-basic">
                  Copyright &copy; 2019 Selena Group. Wszelkie prawa
                  zastrzeżone.
                </p>
              </div>
            </div>
          </section>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js